import { queryOptions } from '@tanstack/react-query';

import rtwClient from '../apiService';

import SitesService from './sitesService';

// **** Queries **** //
export const siteQueryKeys = {
  regions: ['regions'] as const,
};
export const getSiteQueryOptions = {
  regions: () =>
    queryOptions({
      queryKey: siteQueryKeys.regions,
      queryFn: () => SitesService.getRegions(rtwClient),
      // Regions rarely change and are shared across admin pages, so cache them for 5 mins.
      staleTime: 300000,
    }),
};

// **** Mutations **** //
